export default {
  title: 'Welcome to Referent',
  subtitle: "Let's set up your workspace",
  logout: 'Log out',
  noOrganization: {
    title: 'No organization found',
    description: 'Please contact your administrator to be added to an organization.',
  },
  steps: {
    step1: 'Create Organization',
    step2: 'Company Details',
  },
  step1: {
    title: 'Create your organization',
    description: 'Start by creating your organization workspace',
    organizationName: 'Organization name',
    organizationNamePlaceholder: 'My Company Inc.',
    slug: 'URL slug',
    slugPlaceholder: 'my-company',
    nameRequired: 'Organization name is required',
    nameMinLength: 'Name must be at least 3 characters',
    slugRequired: 'Slug is required',
    slugMinLength: 'Slug must be at least 3 characters',
    slugPattern: 'Only lowercase letters, numbers, and hyphens allowed',
    slugAvailable: 'This slug is available',
    slugTaken: 'This slug is already taken',
    continue: 'Create & Continue',
    organizationCreated: 'Organization created successfully',
    errorCreating: 'Failed to create organization',
  },
  step2: {
    title: 'Complete company information',
    description: 'Complete your company information to finish onboarding',
    basicInfo: 'Basic Information',
    companyDetails: 'Company Details',
    products: 'Products',
    enrichWithAI: 'Enrich with AI',
    enriching: 'Enriching...',
    enrichSuccess: 'Company data enriched successfully with AI',
    enrichError: 'Failed to enrich company data',
    websiteUrl: 'Website URL',
    industry: 'Industry',
    selectIndustry: 'Select industry',
    industries: {
      technology: 'Technology',
      healthcare: 'Healthcare',
      finance: 'Finance',
      retail: 'Retail',
      manufacturing: 'Manufacturing',
      other: 'Other',
    },
    companySize: 'Company Size',
    selectSize: 'Select size',
    employees: 'employees',
    address: 'Address',
    contactEmail: 'Contact Email',
    contactEmailRequired: 'Contact email is required',
    contactEmailInvalid: 'Enter a valid email address',
    positioning: 'Market Positioning',
    positioningRequired: 'Market positioning is required',
    positioningPlaceholder: 'How does your company position itself in the market?',
    problemSolved: 'Problem Solved',
    problemSolvedRequired: 'Problem solved is required',
    problemSolvedPlaceholder: 'What core problem does your company solve?',
    valueProposition: 'Value Proposition',
    valuePropositionRequired: 'Value proposition is required',
    valuePropositionPlaceholder: 'What unique value does your company provide?',
    objectives: 'Business Objectives',
    objectivesRequired: 'Business objectives are required',
    objectivesPlaceholder: 'What are your main business objectives?',
    addProduct: 'Add Product',
    noProducts: 'No products added yet. Click "Add Product" to get started.',
    productName: 'Product Name',
    productNamePlaceholder: 'e.g., Analytics Dashboard',
    productDescription: 'Description',
    productDescriptionPlaceholder: 'Brief description of the product',
    productCategory: 'Category',
    productCategoryPlaceholder: 'e.g., SaaS, Software, Service',
    back: 'Back',
    complete: 'Complete Onboarding',
    onboardingCompleted: 'Welcome! Your workspace is ready.',
    errorCompleting: 'Failed to complete onboarding',
    websiteUrlRequired: 'Website URL is required',
    industryRequired: 'Industry is required',
    companySizeRequired: 'Company size is required',
    addressRequired: 'Address is required',
  },
}
